module.exports = __webpack_public_path__ + "static/media/writing_recog_demo.c5b04298.mp4";